import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DepartmentService } from '../../../_services/department.service';
import { CategoryService } from '../../../_services/category.service';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';
import { LearningPathService } from '../../../_services/learning-path.service';
import { ResponseStructure } from '@iq-central-front-end/share';
import { Subscription } from 'rxjs';
import { DivisionService } from '../../../_services/division.service';
import { UnitService } from '../../../_services/unit.service';

@Component({
  selector: 'iq-central-front-end-edit-learning-path',
  templateUrl: './edit-learning-path.component.html',
  styleUrls: ['./edit-learning-path.component.scss'],
})
export class EditLearningPathComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  learningPathForm: FormGroup;
  learningPath: any;
  categories: any[] = [];
  courseCodes: any[] = [];
  subCategories: any[] = [];
  departments: any[] = [];
  restrictionIdFromLp;
  restrictionId: any;
  courses: any[] = [];
  selectedCourses: any[] = [];
  restrictionType: any;
  selectCourses: any[] = [];
  division: boolean;
  department: boolean;
  unit: boolean;
  divisions: any[] = [];
  units: any[] = [];
  filteredCourses: any;
  constructor(
    private fb: FormBuilder,
    private _department: DepartmentService,
    private _category: CategoryService,
    private _course: CourseService,
    private global: GlobalService,
    private _learning: LearningPathService,
    private _division: DivisionService,
    private _unit: UnitService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getResolvedData();
    this.initLearningPath();
    if (this.learningPath.restricted) {
      if (this.learningPath.division) {
        this.restrictionIdFromLp = this.learningPath.division.id;
      } else if (this.learningPath.unit) {
        this.restrictionIdFromLp = this.learningPath.unit.id;
      } else if (this.learningPath.department) {
        this.restrictionIdFromLp = this.learningPath.department.id;
      }
    }
  }
  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.learningPath = res['resolvedData'].learningPath['responseResult'];
        this.selectedCourses = this.learningPath.courses;
        this.courses = this.filteredCourses =
          res['resolvedData'].courses['responseResult'];
        this.categories = res['resolvedData'].categories['responseResult'];
      })
    );
  }

  filter(query: string) {
    this.courses = query
      ? this.filteredCourses.filter((c) =>
          c.title.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredCourses;
  }

  initLearningPath() {
    this.learningPathForm = this.fb.group({
      name: [this.learningPath.name],
      description: [this.learningPath.description],
      dueDate: [this.learningPath.dueDate],
      restricted: this.learningPath.restricted,
    });
  }
  getSubcatecories(categoryId) {
    categoryId == null ? null : this.global.showSpinner();
    this._category.getAllSubcategories(categoryId).subscribe((res) => {
      this.global.hideSpinner();
      this.subCategories = res['responseResult'];
    });
  }

  getDivisions() {
    this.global.showSpinner();
    this._division.getAllDivisions().subscribe((res) => {
      this.global.hideSpinner();
      this.divisions = res['responseResult'];
    });
  }
  getUnits() {
    this.global.showSpinner();
    this._unit.getAllUnits().subscribe((res) => {
      this.global.hideSpinner();
      this.units = res['responseResult'];
    });
  }

  getDepartments() {
    this.global.showSpinner();
    this._department.getAllDepartments().subscribe((res) => {
      this.global.hideSpinner();
      this.departments = res['responseResult'];
    });
  }

  setRestrictedId(restrictionId, restrictionType) {
    this.restrictionId = restrictionId;
    this.restrictionType = restrictionType;
  }
  selectDeselectCourse(course) {
    this.selectCourses.includes(course)
      ? (this.selectCourses = this.selectCourses.filter((c) => c != course))
      : this.selectCourses.push(course);
  }
  addCourse() {
    this.selectCourses.forEach((c) => {
      this.selectedCourses.map((x) => x['id']).includes(c.id)
        ? null
        : this.selectedCourses.push(c);
    });
  }
  removeCourse(course) {
    this.selectedCourses = this.selectedCourses.filter((c) => c != course);
  }
  updateLearningPath(id) {
    this.global.showSpinner();
    this.selectedCourses.forEach((c) => {
      this.courseCodes.push(c.code);
    });
    const payload = this.learningPathForm.value;

    this.restrictionType
      ? (payload.restrictionType = this.restrictionType)
      : (payload.restrictionType = this.learningPath.restriction);
    this.restrictionId
      ? (payload.restrictionId = this.restrictionId)
      : (payload.restrictionId = this.restrictionIdFromLp);
    payload.courseCodes = this.courseCodes;
    payload.id = id;

    this._learning.updateLearningPath(payload).subscribe({
      next: (res: ResponseStructure) => {
        this.global.globalSuccessHandler(res);
      },
    });
  }

  getRestriction(restrictionType) {
    console.log(restrictionType);
    if (restrictionType === 'Department') {
      this.getDepartments();
      this.department = true;
      this.division = false;
      this.unit = false;
    } else if (restrictionType === 'Division') {
      this.getDivisions();
      this.division = true;
      this.department = false;
      this.unit = false;
    } else if (restrictionType === 'Unit') {
      this.getUnits();
      this.unit = true;
      this.department = false;
      this.division = false;
    }
  }

  rating(course) {
    var total = 0;
    for (var i in course.courseRatings) {
      total += course.courseRatings[i].rating;
    }
    const rating = total / course.courseRatings.length;
    if (rating >= 1 && rating < 2) {
      return 'one';
    } else if (rating >= 2 && rating < 3) {
      return 'two';
    } else if (rating >= 3 && rating < 4) {
      return 'three';
    } else if (rating >= 4 && rating < 5) {
      return 'four';
    } else if (rating >= 5) {
      return 'five';
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
